import React, { useState } from "react";
import LiteYouTubeEmbed from "react-lite-youtube-embed";

import { VideoPlayerProps } from "./VideoPlayer.types";

import "./VideoPlayer.scss";

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  thumbnailURL,
  youTubeVideoID,
}) => {
  return (
    <div data-testid="VideoPlayer" className="mp-molecules-videoplayer--main">
      <LiteYouTubeEmbed
        id={youTubeVideoID}
        title="YouTube Embed"
        thumbnail={thumbnailURL}
        playerClass="lty-playbtn"
      />
    </div>
  );
};

export default VideoPlayer;
